import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const savedLanguage = localStorage.getItem('language') || 'fr';

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          // Sign :
          "french": "French",
          "english": "English",
          "signin": "Sign in",
          "signup": "Sign up",
          "username": "Username",
          "username-or-email": "Username or email",
          "email": "Email",
          "password": "Password",
          "remember-me": "Remember me",
          "forget-password": "Forget Password?",
          "or-login-email": "or login with email",
          "signin-with-google": "Sign in with Google",
          "confirm-password": "Confirm Password",
          "or-signin": "or sign in",
          "or-signup": "or sign up",

          // Navigation :
          "all": "All",
          "women": "Women",
          "men": "Men",
          "shop": "Shop",
          "stores": "Stores",
          "about": "About",
          "get-free-delivery": "Get free delivery on orders over {{price}}",

          // Home :
          "home": "Home",
          "hero-carousel-text": {
            "item1": "Discover Your Perfect Style",
            "item2": "New Collections Arriving Weekly",
            "item3": "Elevate Your Wardrobe",
            "item4": "Fashion That Speaks Your Language",
            "item5": "Luxury Meets Comfort",
          },
          "hero-carousel-fixed-text": "Experience the latest trends in fashion and style",
          "shop-now": "Shop Now",

          // Hero :
          "hero-tagline": "Streetwear · Morocco",
          "hero-title": "THUNDERMAROC",
          "hero-subtitle": "Premium streetwear — curated fits for the culture.",

          // Instagram :
          "instagram": "Instagram",
          "instagram-follow": "Follow us",
          "instagram-manage": "Instagram Section",
          "site-logo-manage": "Logo",
          "site-logo": "Logo image",
          "site-logo-hint": "Upload your logo. Use a white/light version — the header background is black.",
          "site-logo-required": "Please choose a logo image.",
          "site-logo-saved": "Logo updated.",
          "site-logo-none": "No logo yet",
          "popup-manage": "Welcome popup",
          "popup-hint": "Show a popup to new visitors offering a discount code in exchange for their email.",
          "popup-enabled": "Enable the popup",
          "popup-title": "Popup title",
          "popup-subtitle": "Popup subtitle",
          "popup-coupon": "Coupon code to give",
          "popup-coupon-hint": "Create the coupon in the Coupons page first, then put its exact code here. Visitors get this code by email after entering their address.",
          "popup-saved": "Popup settings saved.",
          "popup-default-title": "Get -10% on your first order",
          "popup-default-subtitle": "Enter your email to receive your discount code.",
          "popup-cta": "Get my code",
          "popup-no-thanks": "No thanks",
          "popup-invalid-email": "Please enter a valid email.",
          "popup-error": "Something went wrong. Please try again.",
          "popup-thanks-title": "You're in!",
          "popup-thanks-text": "Here is your discount code:",
          "popup-code-emailed": "We also sent it to your email.",
          "popup-continue": "Start shopping",
          "instagram-profile": "Profile",
          "instagram-profile-pic": "Profile picture",
          "instagram-username": "Username",
          "instagram-profile-url": "Profile URL",
          "instagram-add-post": "Add post",
          "instagram-post-image": "Post image",
          "instagram-post-url": "Instagram post link",
          "instagram-posts": "Posts",
          "instagram-no-posts": "No posts yet.",
          "instagram-settings-saved": "Instagram profile saved.",
          "instagram-post-required": "Please add an image and a post link.",
          "instagram-post-added": "Post added.",
          "instagram-post-updated": "Post updated.",
          "instagram-post-deleted": "Post deleted.",
          "something-went-wrong": "Something went wrong, please try again.",

          // Product List :
          "products": "Products",
          "product": "Product",
          "new-products": "New products",
          "our-new-collection": "Our new collection",
          "categories": "Categories",
          "our-products-categories": "Our products categories",

          "category-carousel": {
            "tracksuits": "Tracksuits",
            "sweatshirts": "Sweatshirts & Zippers",
            "jackets": "Jackets",
            "jeans": "Jeans & Cargos",
            "shirts": "Shirts & Tops",
            "jerseys": "Jerseys",
            "accessories": "Accessories",
          },
          "view-all": "View all",

          // Footer :
          "logo-footer-text": "Thunder is a Moroccan brand and shop that merges different universes of clothing, with a focus on streetwear style, offering the best quality and original worldwide brands.",
          "product-categories": "Product categories",
          "customer-service": {
            "item1": "Customer Service",
            "item2": "Contact Us",
            "item3": "FAQ",
            "item4": "Shipping & Returns",
            "item5": "Order Tracking"
          },
          "about-us": {
            "item1": "About us",
            "item2": "Our story",
            "item3": "Sustainability",
            "item4": "Careers",
            "item5": "Press"
          },

          // Shop :
          "all-our-products": "All our products",
          "all-products": "All products",

          // Shopping cart :
          "shopping-cart": "Shopping cart",
          "remove": "Remove",
          "subtotal": "Subtotal",
          "shipping-text": "Shipping and taxes calculated at checkout.",
          "or": "or",
          "continue-shopping": "Continue Shopping",
          "checkout": "Checkout",

          // Search :
          "search": "Search",
          "search-products": "Search products...",
          "search-new-arrivals": "Search new arrivals...",
          "search-customers": "Search customers...",
          "no-found-title": "No results found",
          "no-found-text": "Try adjusting your search to find what you're looking for.",
          "results-found": "Results found",

          // Toast :
          "s-login": "Login successful!",
          "e-login": "Login failed. Please try again.",
          "s-register": "Registration successful!",
          "e-register": "Registration failed. Please try again.",
          "error-not-match": "Passwords do not match",
          "error-unique-username": "This username is already taken.",
          "error-unique-email": "This email is already registered.",

          // Dashboard (English):
          "all-categories": "All categories",
          "add-category": "Add category",
          "all-sizes": "All sizes",
          "add-size": "Add size",
          "search-sizes": "Search sizes...",
          "add-size-success": "Size added successfully!",
          "add-size-error": "Error adding size.",
          "create": "Create",
          "edit": "Edit",
          "cancel": "Cancel",
          "search-categories": "Search categories...",
          "add-category-success": "Category added successfully!",
          "add-category-error": "Error adding category.",
          "add-bag-success": "The item is added to the bag!",
          "add-bag-error": "Error adding the item to the bag.",

          // Edit action (English):
          "edit-category-success": "Category edited successfully!",
          "edit-size-success": "Size edited successfully!",
          "edit-size-error": "Error editing size.",
          "edit-category-error": "Error editing category.",

          // Delete action (English):
          "delete-confirmation-header": "Confirm Deletion",
          "delete-confirmation-body": "Are you sure you want to delete this item? This action cannot be undone.",

          "delete-category-success": "Category deleted successfully!",
          "delete-size-success": "Size deleted successfully!",
          "delete-size-error": "Error deleting size.",
          "delete-category-error": "Error deleting category.",
          "delete-order-success": "Order deleted successfully!",
          "delete-order-error": "Error deleting order.",
          "delete-review-success": "Review deleted successfully!",
          "delete-review-error": "Error deleting review.",
          "logout-confirmation-header": "Confirm Logout",
          "logout-confirmation-body": "Are you sure you want to logout?",

          "category-id": "Category ID",
          "size-id": "Size ID",
          "sizes": "Sizes",
          "size": "Size",
          "name": "Name",
          "description": "Description",
          "actions": "Actions",
          "quantity": "Quantity",
          "confirm": "Confirm",

          "view": "view",
          "quick-view": "quick view",
          "reviews": "reviews",
          "add-bag": "Add to cart",
          "buy-now": "Buy it now",
          "tax-included": "Tax included.",
          "recent-reviews": "Recent reviews",
          "review-text": {
            "item1": "Share your thoughts",
            "item2": "If you've used this product, share your thoughts with other customers",
          },
          "write-review": "Write a review",
          "submit": "Submit",
          "addreview": "Add a review",
          "outof": "out of",
          "review-desc": "The comment",

          "s-add-rev": "Review added successfully!",
          "e-add-rev": "Failed to add review. Please try again.",
          "s-remove-rev": "Review removed successfully!",
          "e-remove-rev": "Failed to remove review. Please try again.",
          "see-more": "See more",
          "see-less": "See less",
          "size-warning": "You must determine the size!",
          "of": "of",

          // Filter :
          "category": "Category",
          "gender": "Gender",
          "availability": "Availability",
          "sort": "Sort",
          "sort-by": "Sort by",
          "in-stock": "In Stock",
          "out-of-stock": "Out of Stock",
          "name-a-z": "Name (A to Z)",
          "name-z-a": "Name (Z to A)",
          "price-low-high": "Price (Low to High)",
          "price-high-low": "Price (High to Low)",
          "newest": "Newest First",
          "oldest": "Oldest First",

          "logout": "Log out",
          "pos-terminal": "POS Terminal",
          "logout-msg": "Logged out successfully",
          "logout-msg-err": "Log out failed",
          "empty-bag": "Your bag is currently empty.",
          "unauth-bag": {
            "item1": "You need to",
            "item2": "sign up",
            "item3": "to add items to your bag.",
            "item4": "If you already have an account, please",
            "item5": "sign in.",
          },

          // Account setting :
          "settings": "Settings",
          "account": "Account",
          "hello": "Hello",
          "hello-1": "From your account dashboard you can view your recent orders, manage your shipping and billing addresses, and edit your password and account details.",
          "orders": "Orders",
          "order": "Order",
          "dashboard": "Dashboard",
          "payment": "Payment",
          "account-details": "Account details",

          "all-orders": "All orders",
          "all-orders-1": "No order has been made yet.",
          "all-orders-2": "Browse products",

          "purchases": "Purchases",
          "my-purchases": "My purchases",
          "all-purchases": "All my purchases",
          "all-purchases-1": "No purchase has been made yet.",

          "preorders": "Preorders",
          "my-preorders": "My Preorders",
          "all-preorders": "All My Preorders",
          "all-preorders-1": "No preorders have been made yet.",

          "all-purchases-2": "Browse products",

          "add-payment": "Add payment method",
          "all-payment-methods": "All my payment methods",

          "fullname": "Full name",
          "ur-fullname": "Your full name",
          "fname": "First name",
          "lname": "Last name",
          "save": "Save",
          "leave-blank": "leave blank to leave unchanged",

          "edit-username": "Your current username is",
          "new-name": "You can add the full name here",
          "edit-name": "Your current full name is",
          "edit-email": "Email Address",
          "edit-email-1": "Your current email is",
          "edit-password": "Password change",
          "edit-password-1": "Do you want to change your",
          "edit-password-2": "current password",
          "current-password": "Current password",
          "new-password": "New password",
          "conf-new-password": "Confirm new password",
          "error-username": "The username has already been taken",
          "s-up-username": "Username updated successfully!",
          "e-up-username": "Failed to update username. Please try again.",
          "s-up-email": "Email updated successfully!",
          "e-up-email": "Failed to update email. Please try again.",
          "s-up-psw": "Password updated successfully!",
          "e-up-psw": "Failed to update password. Please try again.",
          "e-current-psw": "The current password is incorrect.",

          // checkout :
          "phone": "Phone",
          "city": "City",
          "ur-city": "Your city",
          "ur-phone": "Your phone",
          "country": "Country",
          "morocco": "Morocco",
          "ur-country": "Your country",
          "postcode": "Post code",
          "ur-postcode": "Your post code",
          "ppayment": "Payment",
          "credit-card": "Credit card",
          "cardnumber": "Card number",
          "cardexpiration": "Card expiration",
          "expirationdate": "Expiration date",
          "placeorder": "Place order",
          "address-line": "Address line",
          "ur-address-line": "Your address line",

          // dashboard product :
          "add-product": "Add product",
          "add-product-success": "Product added successfully!",
          "add-product-error": "Failed to add product.",
          "update-product-success": "Product updated successfully!",
          "update-product-error": "Failed to update product.",
          "delete-product-success": "Product deleted successfully!",
          "delete-product-error": "Failed to delete product.",

          "region": "Region",
          "select-city": "Select city",
          "select-region": "Select region",
          "payment-details": "Détails du paiement",
          "process-payment-success": "Thank you so much for your order! We truly appreciate your purchase.",
          "process-payment-error": "Error processing payment.",
          "date&time": "Date & time",
          "payment-method": "Payment method",
          "my-transactions": "My transactions",
          "all-transactions": "All transactions",
          "all-transactions-1": "No transaction has been made yet.",
          "amount": "Amount",
          "total-amount": "Total amount",
          "warning-rating-required": "Please select a rating before submitting your review.",
          "login-fill-form-warning": "Please fill in all fields.",

          "customer": "Customer",
          "create-account": "Create an account",
          "date-reg": "Date of registration",
          "delete": "delete",
          "delete-customer-success": "Customer deleted successfully!",
          "delete-customer-error": "Failed to delete customer.",
          "recommended-for-you": "Recommended for You",
          "our-products": "Our products",
          "preview": "Preview",

          "duplicate-product": "Duplicate the product",
          "confirm-duplicate-product-header": "Confirm Duplicate Product",
          "confirm-duplicate-product-text": "Are you sure you want to duplicate this product?",
          "duplicate-product-success-toast": "Product duplicated successfully!",
          "duplicate-product-error-toast": "Failed to duplicate product.",

          "slide": "Slide",
          "slides": "Slides",
          "all-slides": "All slides",
          "search-slides": "Search slides...",
          "add-slide": "Add slide",
          "delete-slide-success": "Slide deleted successfully!",
          "delete-slide-error": "Failed to delete slide.",
          "update-slide-success": "Slide updated successfully!",
          "update-slide-error": "Failed to update slide.",
          "create-slide-success": "Slide created successfully!",
          "create-slide-error": "Failed to create slide.",

          // Color :
          "all-colors": "All colors",
          "add-color": "Add color",
          "search-colors": "Search colors...",
          "search-orders": "Search orders...",
          "search-transactions": "Search transactions...",
          "add-color-success": "Color added successfully!",
          "add-color-error": "Error adding color.",
          "color-warning": "You must determine the color!",
          "edit-color-success": "Color edited successfully!",
          "edit-color-error": "Error editing color.",
          "delete-color-success": "Color deleted successfully!",
          "delete-color-error": "Error deleting color.",
          "color-id": "Color ID",
          "order-id": "Order ID",
          "colors": "Colors",
          "color": "Color",
          "guest": "Guest",
          "customer-type": "Customer type",
          "pay": "Pay",
          "reference": "Reference",
          "address": "Address",
          "status": "Status",

          "pending": "Pending",
          "in_progress": "In progress",
          "completed": "Completed",
          "canceled": "Canceled",
          "out-for-delivery": "Out for delivery",
          "delivered": "Delivered",
          "cash-on-delivery": "Cash on delivery",
          "order-date": "Order date",

          "delivery-status": "Delivery Status",
          "select-delivery-status": "Select delivery status",
          "order-status": "Order Status",
          "select-order-status": "Select order status",
          "save-changes": "Save Changes",

          "save-order-details-success": "Changes to order details saved successfully!",
          "save-order-details-error": "Failed to save changes to order details.",

          "back": "Back",
          "crs-create-slide": "Create New Slide",
          "crs-slide-description": "Fill in the details below to create a new slide.",
          "carousel-image-area-note-1": "PNG, JPG or PDF, smaller than 5MB",
          "carousel-image-area-note-2": "For best display, please upload images with a 16:9 aspect ratio.",
          "crs-drop-and-drag": "Drag and Drop your file here or",
          "crs-choose-file": "Choose File",
          "crs-create-slide-button": "Create Slide",
          "file-name": "File name",
          "crs-update-slide": "Update The Slide",
          "crs-update-slide-description": "Fill in the details below to update the slide.",
          "crs-update-slide-button": "Update Slide",
          "name-card": "Name on card",
          "ur-name-card": "Your name on card",

          "co-credit-card": "Credit Card Details",
          "pay-paypal": "Pay with PayPal",
          "pay-paypal-text": "You will be redirected to PayPal to complete your payment securely.",
          "cash-delivery": "Cash on Delivery",
          "cash-delivery-text-1": "Pay with cash when your order is delivered to your doorstep.",
          "cash-delivery-text-2": "Have the exact amount ready",
          "cash-delivery-text-3": "Our delivery person will provide a receipt",
          "pay-delivery": "Pay on Delivery",
          "details": "Details",
          "order-details": "Order details",
          "preorder-details": "Preorder details",
          "customer-info": "Customer Information",
          "order-items": "Order Items",
          "stock-management": "Stock management",
          "stock-total": "Stock total",
          "rating": "Rating",
          "price": "Price",

          "edit-stock-success": "Stock edited successfully!",
          "edit-stock-error": "Error editing stock.",
          "delete-stock-success": "Stock cleared successfully!",
          "delete-stock-error": "Error clearing stock.",
          "stock-msg": "The stock being added will apply to all sizes of the product.",
          "back-to-products": "Back to products",
          "insufficient-stock": "Insufficient stock",

          // Coupon :
          "all-coupons": "All coupons",
          "add-coupon": "Add coupon",
          "search-coupons": "Search coupons...",
          "add-coupon-success": "Coupon added successfully!",
          "add-coupon-error": "Error adding coupon.",
          "coupon-warning": "You must provide the coupon code!",
          "edit-coupon-success": "Coupon edited successfully!",
          "edit-coupon-error": "Error editing coupon.",
          "delete-coupon-success": "Coupon deleted successfully!",
          "delete-coupon-error": "Error deleting coupon.",
          "coupon-id": "Coupon ID",
          "coupons": "Coupons",
          "coupon": "Coupon",
          "cpn-code": "Coupon Code",

          "promotions": "Offers",
          "add-promotion": "Add offer",
          "edit-promotion": "Edit offer",
          "promo-name": "Offer name",
          "promo-rule": "Rule",
          "promo-buy": "Buy",
          "promo-free": "free",
          "promo-buy-qty": "Buy quantity",
          "promo-free-qty": "Free quantity",
          "promo-starts-at": "Starts at",
          "promo-ends-at": "Ends at",
          "promo-dates-hint": "Leave a date empty to run with no limit on that side.",
          "promo-popup": "Popup",
          "promo-popup-enabled": "Show announcement popup on the website",
          "promo-popup-title": "Popup title",
          "promo-popup-subtitle": "Popup subtitle",
          "promo-popup-cta": "Button text",
          "promo-page-hint": "Buy X get Y free. The cheapest items in the cart are the free ones.",
          "promo-empty": "No offers yet.",
          "promo-live": "Live now",
          "promo-scheduled": "Scheduled",
          "promo-expired": "Expired",
          "promo-running-note": "is live — coupon codes are disabled while it runs.",
          "promo-name-required": "Give the promotion a name.",
          "promo-qty-invalid": "Buy and free quantities must be at least 1.",
          "promo-dates-invalid": "The end date must be after the start date.",
          "promo-created": "Offer created.",
          "promo-updated": "Offer updated.",
          "promo-save-error": "Could not save the offer.",
          "delete-promotion-success": "Offer deleted successfully!",
          "delete-promotion-error": "Error deleting the offer.",
          "promo-one-item-free": "Your cheapest item is free.",
          "promo-n-items-free": "Your {{num}} cheapest items are free.",
          "promo-no-coupon-note": "Coupon codes can't be combined with this offer.",
          "promo-nudge-one": "Add 1 more item and your cheapest one is free!",
          "promo-nudge-many": "Add {{num}} more items and your cheapest one is free!",
          "promo-applied-at-checkout": "Your discount is applied at checkout.",
          "active": "Active",
          "on": "On",
          "off": "Off",
          "cpn-discount-type": "Discount Type",
          "cpn-value": "Value",
          "cpn-min-order": "Min Order",
          "cpn-expiry-date": "Expiry Date",
          "cpn-usage-limit": "Usage Limit",
          "fixed": "Fixed Amount",
          "percentage": "Percentage",
          "generate": "Generate",
          "expired": "Expired",

          "enter-coupon": "Enter a coupon code.",
          "coupon-invalid": "Invalid coupon.",
          "coupon-applied": "Coupon applied successfully!",
          "coupon-error": "Invalid coupon.",
          "coupon-code-placeholder": "Coupon code",
          "checking": "Checking...",
          "apply": "Apply",
          "discount": "Discount",
          "discount-amount": "Montant de la remise",
          "times-used": "Times used",

          "inactive": "Inactive",
          "id": "ID",
          "city-name": "City name",
          "delivery-price": "Delivery price",
          "estimated-days": "Estimated days",
          "delivery-cities": "Delivery cities",
          "search-cities": "Search cities...",
          "add-city": "Add city",
          "city-name-required": "City name is required.",
          "delivery-price-invalid": "Delivery price is invalid.",
          "add-city-success": "City added successfully!",
          "add-city-error": "Error adding city.",
          "edit-city-error": "Error fetching city.",
          "edit-city-success": "City updated successfully!",
          "city-name-placeholder": "e.g. Casablanca",
          "delete-delivery-error": "Error deleting delivery city.",
          "delete-delivery-success": "Delivery city deleted successfully!",

          "select": "Select",
          "select-all": "Select all",
          "unselect-all": "Unselect all",
          "edit-selected": "Edit selected",
          "delete-selected": "Delete selected",
          "confirm-delete-selected": "Are you sure you want to delete the selected cities?",
          "bulk-update-success": "Selected delivery cities updated successfully!",
          "bulk-update-error": "Error updating selected delivery cities.",

          "loading": "Loading",
          "delivery_with_price": "Delivery will cost you {{price}} MAD",
          "delivery": "Delivery",
          "free-delivery-label": "Free delivery",
          "free-delivery-note": "Congratulations! Orders over {{threshold}} MAD get free delivery.",
          "free-delivery-from": "Free delivery from",
          "minimum-amount": "Minimum amount (MAD)",
          "minimum-amount-invalid": "Minimum amount is invalid",
          "threshold-saved": "Threshold saved successfully",
          "activate-free-delivery": "Activate free delivery threshold",
          "disabled": "Disabled",

          "newsletter": {
            "title": "Newsletter",
            "text": "Stay updated with our latest arrivals, exclusive offers, and trends.",
            "fullname": "Full Name",
            "email": "Email Address",
            "phone": "Phone Number",
            "subscribe": "Subscribe",
            "success": "You have successfully subscribed to our newsletter!",
            "error": "An error occurred while subscribing. Please try again.",
            "warning": "Please fill in at least one field before submitting!",
            "confirm-export": "Are you sure you want to export all subscribers?",
            "export-error": "Failed to export subscribers.",
            "confirm-export-title": "Export Subscribers",
            "confirm-export-text": "Are you sure you want to export all subscribers?",
            "export-csv": "Export CSV",
            "export-success": "Export completed successfully!",
            "compose": "Compose newsletter",
            "subject": "Subject",
            "message": "Message",
            "to-subscribers": "Newsletter subscribers",
            "to-customers": "Registered customers",
            "manual": "Add emails manually (comma-separated)",
            "send": "Send newsletter",
            "sending": "Sending...",
            "sent": "Newsletter sent to",
            "send-missing": "Please enter a subject and a message.",
            "send-no-recipients": "Please choose at least one recipient group or add emails.",
            "limit-note": "Note: shared hosting limits bulk email (~a few hundred/hour). For large lists, use a dedicated email service.",
          },
          "copyright": "© 2025 Thunder Maroc. All rights reserved.",
          "contact-info": "Contact information",
          "visit-us": "Visit us",
          "open-in-maps": "Open our location in Google Maps",
          "delete-newsletter-success": "Subscriber deleted successfully!",
          "delete-newsletter-error": "Failed to delete subscriber.",

          "newsletter-list": "Newsletter Subscribers",
          "export-csv": "Export CSV",
          "search-client": "Search subscribers...",
          "client-id": "Client ID",
          "full-name": "Full Name",
          "date": "Subscription Date",
          "sort-newest": "Sort by Oldest",
          "sort-oldest": "Sort by Newest",
          "shipping-address": "Shipping Address",
          "thank_you_purchase": "Thank you for your purchase",
          "cpn-usage-limit-per-user": "Usage limit per user",

          "messages": {
            "error_try_again": "Something went wrong, please try again.",
            "coupon_not_found": "We couldn't find a coupon with that code.",
            "coupon_inactive": "This coupon is no longer active.",
            "coupon_expired": "This coupon has expired.",
            "coupon_usage_limit_reached": "This coupon has reached its usage limit.",
            "minimum_order_not_reached": "The minimum order value is not met.",
            "usage_limit_per_user_reached": "You have reached the usage limit for this coupon.",
            "session_or_user_required": "You need to be logged in or provide a session ID to redeem the coupon.",
          },
          "increase_quantity": "Increase quantity",
          "decrease_quantity": "Decrease quantity",
          "selected-from": "selected from",
          "update-product": "Update Product",
          "modify-product-details": "Modify the product details below.",
          "create-new-product": "Create New Product",
          "fill-details-to-create-product": "Fill in the details below to create a new product listing.",
          "english-name": "English Name",
          "french-name": "French Name",
          "english-description": "English Description",
          "french-description": "French Description",
          "select-gender": "Select Gender",
          "select-category": "Select Category",
          "create-product": "Create Product",
          "is_nouvel_arrivage_question": "Is this a new arrival ?",
          "is_nouvel_arrivage_available_question": "Is this a new arrival available in the stock ?",
          "is_nouvel_arrivage_available_question_note": "(it will be displayed in the shop)",
          "oui": "Yes",
          "non": "No",
          "all-new-arrivals": "All new arrivals",
          "new-arrivals": "New arrivals",
          "new-arrival": "New arrival",
          "new-arrivals-subtitle": "Discover Our Latest Products",
          "new-arrivals-description": "Explore the newest additions to our collection, featuring the latest trends and exclusive items. Be the first to grab these fresh arrivals before they're gone!",
          "available": "Available",
          "unavailable": "Unavailable",

          "error-google-auth": "Failed to authenticate with Google",
          "processing-auth": "Completing authentication...",
          "please-wait": "Please wait a moment",
          "pre-order": "Preorder",
          "pre-orders": "Preorders",
          "pre-order-text-1": "Secure your items before they are officially available. You'll receive an email notification once your order is in stock and ready for shipping.",
          "pre-order-text-2": "You are reserving a new product that will be available in the future.",
          "pre-order-text-3": "We will notify you via email when the product is in stock and ready to be shipped.",
          "place-pre-order": "Place preorder",

          "add-bag-error-nouvel-arrivage": "You can't add a preorder item while an available product is in your cart. Complete your current order first.",
          "add-bag-error-available-product": "You can't add an available item while a preorder product is in your cart. Complete your preorder first.",

          "all-pre-orders": "All preorders",
          "all-pre-orders-1": "No preorder has been made yet.",
          "search-pre-orders": "Search preorders...",

          "preorder-availability-alert": "We will notify you by email when your products become available.",
          "preorder-confirm-header": "Confirm the changes",
          "preorder-confirm-text": "This preorder will be moved to orders. \n & a confirmation email will be sent to the client.",
          "preorder-cancel-header": "Cancel Preorder",
          "preorder-cancel-text": "This preorder will be cancelled.",

          "order-confirm-text": "This order will be processed. \n & a confirmation email will be sent to the client.",
          "order-cancel-header": "Cancel Order",
          "order-cancel-text": "This order will be cancelled.",
          "email-doesnt-exist-err": "The email address provided does not exist.",
          "2pic-uploaded": "2 photos must be uploaded.",
          "replace-imgs": "Replace Images (exactly 2 files)",
          "2pic-existing-files": "If you upload images they must be exactly 2 and will replace existing images.",

          "forgot-password-title": "Forgot your password?",
          "forgot-password-text": "Just enter your email address below, and we'll send you instructions to reset your password.",
          "reset-password": "Reset password",
          "reset-password-title": "Reset your password",
          "reset-password-text": "Please enter a new password below to reset your account. Make sure it's something secure that you'll remember.",
          "notif-reset-link-title": "Password Reset Notification",
          "notif-reset-link-text": "The recent password reset link has been sent to your email. Please check your inbox and note that it may have been received in your spam folder.",
          "iunderstand": "I understand",
          "er-forgotpsw": "No account found for this email address",

          "promo-newPrice": "New price",
          "promo-oldPrice": "Original Price",
          "promo-promotionLabel": "Promotion",
          "promo-addSuccess": "Promotion added successfully!",
          "promo-addError": "Could not add promotion. Please check the details and try again.",
          "activate-promotion": "Activate Promotion",

          "background-color": "Background color",
          "text-color": "Text color",
          "show-button-on-slide": "Show the button on this slide",
          "note-empty-title-description-slides": "You can leave the “Title” and “Description” fields blank; only the image will appear on the slide.",
          "info-alert": "Info alert!",
          "button-link": "Bouton « Lien »",
          "button-label": "Bouton « Label »",

        }
      },
      fr: {
        translation: {
          // Sign :
          "french": "Français",
          "english": "Anglais",
          "signin": "Se connecter",
          "signup": "S'inscrire",
          "username": "Nom d'utilisateur",
          "username-or-email": "Nom d'utilisateur ou e-mail",
          "email": "Adresse e-mail",
          "password": "Mot de passe",
          "remember-me": "Souviens-toi de moi",
          "forget-password?": "Mot de passe oublié?",
          "or-login-email": "ou se connecter avec un e-mail",
          "signin-with-google": "Se connecter avec Google",
          "confirm-password": "Confirmer le mot de passe",
          "or-signin": "ou se connecter",
          "or-signup": "ou s'inscrire",

          // Navigation :
          "all": "Tout",
          "women": "Femmes",
          "men": "Hommes",
          "shop": "Boutique",
          "stores": "Magasins",
          "about": "À propos",
          "get-free-delivery": "Livraison gratuite pour les commandes de plus de {{price}}",

          // Home :
          "home": "Accueil",
          "hero-carousel-text": {
            "item1": "Découvrez Votre Style Parfait",
            "item2": "Nouvelles Collections Arrivant Hebdomadairement",
            "item3": "Élevez Votre Garde-robe",
            "item4": "La Mode Qui Parle Votre Langage",
            "item5": "Le Luxe Rencontre le Confort",
          },
          "hero-carousel-fixed-text": "Découvrez les dernières tendances de la mode et du style",
          "shop-now": "Achetez Maintenant",

          // Hero :
          "hero-tagline": "Streetwear · Maroc",
          "hero-title": "THUNDERMAROC",
          "hero-subtitle": "Streetwear premium — des pièces sélectionnées pour la culture.",

          // Instagram :
          "instagram": "Instagram",
          "instagram-follow": "Nous suivre",
          "instagram-manage": "Section Instagram",
          "site-logo-manage": "Logo",
          "site-logo": "Image du logo",
          "site-logo-hint": "Téléchargez votre logo. Utilisez une version blanche/claire — le fond de l'en-tête est noir.",
          "site-logo-required": "Veuillez choisir une image de logo.",
          "site-logo-saved": "Logo mis à jour.",
          "site-logo-none": "Aucun logo",
          "popup-manage": "Popup de bienvenue",
          "popup-hint": "Afficher un popup aux nouveaux visiteurs offrant un code de réduction en échange de leur email.",
          "popup-enabled": "Activer le popup",
          "popup-title": "Titre du popup",
          "popup-subtitle": "Sous-titre du popup",
          "popup-coupon": "Code promo à offrir",
          "popup-coupon-hint": "Créez d'abord le coupon dans la page Coupons, puis mettez son code exact ici. Les visiteurs reçoivent ce code par email après avoir saisi leur adresse.",
          "popup-saved": "Paramètres du popup enregistrés.",
          "popup-default-title": "Obtenez -10% sur votre première commande",
          "popup-default-subtitle": "Entrez votre email pour recevoir votre code de réduction.",
          "popup-cta": "Obtenir mon code",
          "popup-no-thanks": "Non merci",
          "popup-invalid-email": "Veuillez saisir un email valide.",
          "popup-error": "Une erreur s'est produite. Veuillez réessayer.",
          "popup-thanks-title": "C'est fait !",
          "popup-thanks-text": "Voici votre code de réduction :",
          "popup-code-emailed": "Nous l'avons aussi envoyé à votre email.",
          "popup-continue": "Commencer mes achats",
          "instagram-profile": "Profil",
          "instagram-profile-pic": "Photo de profil",
          "instagram-username": "Nom d'utilisateur",
          "instagram-profile-url": "URL du profil",
          "instagram-add-post": "Ajouter une publication",
          "instagram-post-image": "Image de la publication",
          "instagram-post-url": "Lien de la publication Instagram",
          "instagram-posts": "Publications",
          "instagram-no-posts": "Aucune publication pour l'instant.",
          "instagram-settings-saved": "Profil Instagram enregistré.",
          "instagram-post-required": "Veuillez ajouter une image et un lien de publication.",
          "instagram-post-added": "Publication ajoutée.",
          "instagram-post-updated": "Publication mise à jour.",
          "instagram-post-deleted": "Publication supprimée.",
          "something-went-wrong": "Une erreur s'est produite, veuillez réessayer.",

          // Product List :
          "products": "Produits",
          "product": "Produit",
          "new-products": "Nouveaux produits",
          "our-new-collection": "Notre nouvelle collection",
          "Categories": "Catégories",
          "Our products categories": "Nos catégories de produits",

          "category-carousel": {
            "tracksuits": "Survêtements",
            "sweatshirts": "Sweat-shirts & Zippés",
            "jackets": "Vestes",
            "jeans": "Jeans & Cargos",
            "shirts": "Chemises & Hauts",
            "jerseys": "Maillots",
            "accessories": "Accessoires",
          },
          "view-all": "Voir tout",

          // Footer :
          "logo-footer-text": "Thunder est une marque et une boutique marocaine qui fusionne différents univers vestimentaires, avec un accent sur le style streetwear, offrant la meilleure qualité et des marques mondiales originales.",
          "product-categories": "Catégories de produits",
          "customer-service": {
            "item1": "Service client",
            "item2": "Nous contacter",
            "item3": "FAQ",
            "item4": "Expéditions & Retours",
            "item5": "Suivi de commande"
          },
          "about-us": {
            "item1": "À propos de nous",
            "item2": "Notre histoire",
            "item3": "Durabilité",
            "item4": "Carrières",
            "item5": "Presse"
          },

          // Shop :
          "all-our-products": "Tous nos produits",
          "all-products": "Tous les produits",

          // Shopping cart :
          "shopping-cart": "Panier",
          "remove": "Retirer",
          "subtotal": "Sous-total",
          "shipping-text": "Les frais d'expédition et les taxes sont calculés à la caisse.",
          "or": "ou",
          "continue-shopping": "Continuer vos achats",
          "checkout": "Passer à la caisse",

          // Search :
          "search": "Rechercher",
          "search-products": "Rechercher des produits...",
          "search-new-arrivals": "Rechercher des nouveaux arrivages...",
          "search-customers": "Rechercher des clients...",
          "no-found-title": "Aucun résultat trouvé",
          "no-found-text": "Essayez d'ajuster votre recherche pour trouver ce que vous cherchez.",
          "results-found": "Résultats trouvés",

          // Toast :
          "s-login": "Connexion réussie !",
          "e-login": "Échec de la connexion. Veuillez réessayer.",
          "s-register": "Inscription réussie !",
          "e-register": "Échec de l'inscription. Veuillez réessayer.",
          "error-not-match": "Les mots de passe ne correspondent pas",
          "error-unique-username": "Ce nom d'utilisateur est déjà pris.",
          "error-unique-email": "Cet e-mail est déjà enregistré.",

          // Dashboard (French):
          "all-categories": "Toutes les catégories",
          "all-sizes": "Toutes les tailles",
          "add-category": "Ajouter une catégorie",
          "add-size": "Ajouter une taille",
          "create": "Créer",
          "edit": "Modifier",
          "cancel": "Annuler",
          "search-categories": "Rechercher des catégories...",
          "search-sizes": "Rechercher des tailles...",
          "add-category-success": "Catégorie ajoutée avec succès !",
          "add-size-success": "Taille ajoutée avec succès !",
          "add-category-error": "Erreur lors de l'ajout de la catégorie.",
          "add-size-error": "Erreur lors de l'ajout de la taille.",
          "add-bag-success": "L'article est ajouté au panier !",
          "add-bag-error": "Erreur lors de l'ajout de l'article au panier.",

          // Edit action (French):
          "edit-category-success": "Catégorie modifiée avec succès !",
          "edit-size-success": "Taille modifiée avec succès !",
          "edit-category-error": "Erreur lors de la modification de la catégorie.",
          "edit-size-error": "Erreur lors de la modification de la taille.",

          // Delete action (French):
          "delete-confirmation-header": "Confirmer la suppression",
          "delete-confirmation-body": "Êtes-vous sûr de vouloir supprimer cet article ? Cette action est irréversible.",
          "delete-category-success": "Catégorie supprimée avec succès !",
          "delete-size-success": "Taille supprimée avec succès !",
          "delete-category-error": "Erreur lors de la suppression de la catégorie.",
          "delete-size-error": "Erreur lors de la suppression de la taille.",
          "delete-order-success": "Commande supprimée avec succès !",
          "delete-order-error": "Erreur lors de la suppression de la commande.",
          "delete-review-success": "Avis supprimé avec succès!",
          "delete-review-error": "Erreur lors de la suppression de l'avis.",
          "logout-confirmation-header": "Confirmer la déconnexion",
          "logout-confirmation-body": "Êtes-vous sûr de vouloir vous déconnecter ?",

          "category-id": "Catégorie ID",
          "size-id": "Taille ID",
          "sizes": "Tailles",
          "size": "Taille",
          "name": "Nom",
          "description": "Description",
          "actions": "Actions",
          "quantity": "Quantité",
          "confirm": "Confirmer",

          "view": "Voir",
          "quick-view": "Aperçu rapide",
          "reviews": "Avis",
          "add-bag": "Ajouter au panier",
          "buy-now": "Acheter maintenant",
          "tax-included": "Taxes incluses.",
          "recent-reviews": "Avis récents",
          "review-text": {
            "item1": "Partagez vos impressions",
            "item2": "Si vous avez utilisé ce produit, partagez vos impressions avec d'autres clients"
          },
          "write-review": "Écrire un avis",
          "submit": "Envoyer",
          "addreview": "Ajouter un commentaire",
          "outof": "sur",
          "review-desc": "Le commentaire",

          "s-add-rev": "Avis ajouté avec succès!",
          "e-add-rev": "Échec de l'ajout de l'avis. Veuillez réessayer.",
          "s-remove-rev": "Avis supprimé avec succès!",
          "e-remove-rev": "Échec de la suppression de l'avis. Veuillez réessayer.",
          "see-more": "Voir plus",
          "see-less": "Voir moins",
          "size-warning": "Vous devez déterminer la taille !",
          "of": "sur",

          // Filter :
          "category": "Catégorie",
          "gender": "Genre",
          "availability": "Disponibilité",
          "sort": "Trier",
          "sort-by": "Trier par",
          "in-stock": "En stock",
          "out-of-stock": "Rupture de stock",
          "name-a-z": "Nom (A à Z)",
          "name-z-a": "Nom (Z à A)",
          "price-low-high": "Prix (croissant)",
          "price-high-low": "Prix (décroissant)",
          "newest": "Plus récents",
          "oldest": "Plus anciens",

          "logout": "Déconnexion",
          "pos-terminal": "Terminal POS",
          "logout-msg": "Déconnexion réussie",
          "logout-msg-err": "Échec de la déconnexion",
          "empty-bag": "Votre panier est actuellement vide.",
          "unauth-bag": {
            "item1": "Vous devez vous",
            "item2": "inscrire",
            "item3": "pour ajouter des articles à votre panier.",
            "item4": "Si vous avez déjà un compte, veuillez vous",
            "item5": "connecter.",
          },

          // Account setting :
          "settings": "Paramètres",
          "account": "Compte",
          "hello": "Bonjour",
          "hello-1": "Depuis le tableau de bord de votre compte, vous pouvez voir vos commandes récentes, gérer vos adresses de livraison et de facturation, et modifier votre mot de passe et les détails de votre compte.",
          "orders": "Commandes",
          "order": "Commande",
          "dashboard": "Tableau de bord",
          "account-details": "Détails du compte",

          "purchases": "Achats",
          "my-purchases": "Mes achats",
          "all-purchases": "Tous mes achats",
          "all-purchases-1": "Aucun achat n'a encore été effectué.",

          "preorders": "Précommandes",
          "my-preorders": "Mes précommandes",
          "all-preorders": "Toutes mes précommandes",
          "all-preorders-1": "Aucune précommande n'a encore été effectuée.",

          "all-purchases-2": "Parcourir les produits",

          "all-orders": "Toutes les commandes",
          "all-orders-1": "Aucune commande n'a encore été passée.",
          "all-orders-2": "Parcourir les produits",

          "add-payment": "Ajouter un moyen de paiement",
          "all-payment-methods": "Tous mes modes de paiement",

          "fullname": "Nom et prénom",
          "ur-fullname": "Votre nom et prénom",
          "fname": "Prénom",
          "lname": "Nom de famille",
          "save": "Enregistrer",
          "leave-blank": "laisser vide pour ne pas changer",
          "edit-username": "Votre nom d'utilisateur actuel est",
          "new-name": "Vous pouvez ajouter le nom complet ici",
          "edit-name": "Votre nom complet actuel est",
          "edit-email": "Adresse e-mail",
          "edit-email-1": "Votre e-mail actuel est",
          "edit-password": "Changement de mot de passe",
          "edit-password-1": "Voulez-vous changer votre",
          "edit-password-2": "mot de passe actuel?",
          "current-password": "Mot de passe actuel",
          "new-password": "Nouveau mot de passe",
          "conf-new-password": "Confirmer le nouveau mot de passe",
          "error-username": "Le nom d'utilisateur a déjà été utilisé",
          "s-up-username": "Nom d'utilisateur mis à jour avec succès!",
          "e-up-username": "Échec de la mise à jour du nom d'utilisateur. Veuillez réessayer.",
          "s-up-email": "Email mis à jour avec succès!",
          "e-up-email": "Échec de la mise à jour de l'email. Veuillez réessayer.",
          "s-up-psw": "Mot de passe mis à jour avec succès!",
          "e-up-psw": "Échec de la mise à jour du mot de passe. Veuillez réessayer.",
          "e-current-psw": "Le mot de passe courant est incorrect.",

          // checkout :
          "phone": "Téléphone",
          "city": "Ville",
          "ur-city": "Votre ville",
          "ur-phone": "Votre téléphone",
          "country": "Pays",
          "morocco": "Maroc",
          "ur-country": "Votre pays",
          "postcode": "Code postal",
          "ur-postcode": "Votre code postal",
          "payment": "Paiement",
          "credit-card": "Carte de crédit",
          "cardnumber": "Numéro de la carte",
          "cardexpiration": "Expiration de la carte",
          "expirationdate": "Date d'expiration",
          "placeorder": "Passer commande",
          "address-line": "Ligne d'adresse",
          "ur-address-line": "Votre ligne d'adresse",

          // dashboard product :
          "add-product": "Ajouter un produit",
          "add-product-success": "Produit ajouté avec succès!",
          "add-product-error": "Échec de l'ajout du produit.",
          "update-product-success": "Produit mis à jour avec succès!",
          "update-product-error": "Échec de la mise à jour du produit.",
          "delete-product-success": "Produit supprimé avec succès!",
          "delete-product-error": "Échec de la suppression du produit.",

          "region": "Région",
          "select-city": "Sélectionner une ville",
          "select-region": "Sélectionner une région",
          "payment-details": "Payment details",
          "process-payment-success": "Merci beaucoup pour votre commande! Nous apprécions sincèrement votre achat.",
          "process-payment-error": "Erreur lors du traitement du paiement.",
          "date&time": "Date et heure",
          "my-transactions": "Mes transactions",
          "all-transactions": "Toutes les transactions",
          "all-transactions-1": "Aucune transaction n'a encore été effectuée.",
          "amount": "Montant",
          "total-amount": "Montant total",
          "warning-rating-required": "Veuillez sélectionner une note avant de soumettre votre avis.",
          "login-fill-form-warning": "Veuillez remplir tous les champs.",

          "customer": "Client",
          "create-account": "Créer un compte",
          "date-reg": "Date de l'inscription",
          "delete": "supprimer",
          "delete-customer-success": "Client supprimé avec succès!",
          "delete-customer-error": "Échec de la suppression du client.",
          "recommended-for-you": "Recommandé pour vous",
          "our-products": "Nos produits",
          "preview": "Aperçu",

          "duplicate-product": "Dupliquer le produit",
          "confirm-duplicate-product-header": "Confirmer la duplication du produit",
          "confirm-duplicate-product-text": "Êtes-vous sûr de vouloir dupliquer ce produit?",
          "duplicate-product-success-toast": "Produit dupliqué avec succès!",
          "duplicate-product-error-toast": "Échec de la duplication du produit.",

          "slide": "Diapositive",
          "slides": "Diapositives",
          "all-slides": "Toutes les diapositives",
          "search-slides": "Rechercher des diapositives...",
          "add-slide": "Ajouter une diapositive",
          "delete-slide-success": "Diapositive supprimée avec succès!",
          "delete-slide-error": "Échec de la suppression de la diapositive.",
          "update-slide-success": "Diapositive mise à jour avec succès!",
          "update-slide-error": "Échec de la mise à jour de la diapositive.",
          "create-slide-success": "Diapositive créée avec succès!",
          "create-slide-error": "Échec de la création de la diapositive.",

          // Color :
          "all-colors": "Toutes les couleurs",
          "add-color": "Ajouter une couleur",
          "search-colors": "Rechercher des couleurs...",
          "search-orders": "Rechercher des commandes...",
          "search-transactions": "Rechercher des transactions...",
          "add-color-success": "Couleur ajoutée avec succès!",
          "add-color-error": "Erreur lors de l'ajout de la couleur.",
          "edit-color-success": "Couleur modifiée avec succès!",
          "edit-color-error": "Erreur lors de la modification de la couleur.",
          "color-warning": "Vous devez déterminer la couleur!",
          "delete-color-success": "Couleur supprimée avec succès!",
          "delete-color-error": "Erreur lors de la suppression de la couleur.",
          "color-id": "Couleur ID",
          "order-id": "Commande ID",
          "colors": "Couleurs",
          "color": "Couleur",
          "guest": "Invité",
          "customer-type": "Type de client",
          "pay": "Payer",
          "reference": "Référence",
          "address": "Adresse",
          "status": "Statut",

          "pending": "En attente",
          "in_progress": "En cours",
          "completed": "Terminé",
          "canceled": "Annulé",
          "out-for-delivery": "En cours de livraison",
          "delivered": "Livré",
          "cash-on-delivery": "Paiement à la livraison",
          "order-date": "Date de commande",

          "payment-method": "Méthode de paiement",
          "delivery-status": "Statut de livraison",
          "select-delivery-status": "Sélectionner le statut de livraison",
          "order-status": "Statut de la commande",
          "select-order-status": "Sélectionner le statut de la commande",
          "save-changes": "Enregistrer les modifications",

          "save-order-details-success": "Les modifications des détails de la commande ont été enregistrées avec succès!",
          "save-order-details-error": "Échec de l'enregistrement des modifications des détails de la commande.",

          "back": "Retour",
          "crs-create-slide": "Créer un nouveau slide",
          "crs-drop-and-drag": "Glissez-déposez votre fichier ici ou",
          "crs-slide-description": "Remplissez les détails ci-dessous pour créer un nouveau slide.",
          "carousel-image-area-note-1": "PNG, JPG ou PDF, inférieur à 5 Mo",
          "carousel-image-area-note-2": "Pour un meilleur affichage, veuillez télécharger des images avec un ratio d'aspect de 16:9.",
          "crs-choose-file": "Choisir un fichier",
          "crs-create-slide-button": "Créer un slide",
          "file-name": "Nom du fichier",
          "crs-update-slide": "Mettre à jour le slide",
          "crs-update-slide-description": "Remplissez les détails ci-dessous pour mettre à jour le slide.",
          "crs-update-slide-button": "Mettre à jour le slide",
          "name-card": "Nom sur la carte",
          "ur-name-card": "Votre nom sur la carte",

          "co-credit-card": "Détails de la carte de crédit",
          "pay-paypal": "Payer avec PayPal",
          "pay-paypal-text": "Vous serez redirigé vers PayPal pour terminer votre paiement en toute sécurité.",
          "cash-delivery": "Paiement à la livraison",
          "cash-delivery-text-1": "Payez en espèces lorsque votre commande est livrée à votre porte.",
          "cash-delivery-text-2": "Ayez le montant exact prêt",
          "cash-delivery-text-3": "Notre livreur vous fournira un reçu",
          "pay-delivery": "Payer à la livraison",
          "details": "Détails",
          "order-details": "Détails de la commande",
          "preorder-details": "Détails de la précommande",
          "customer-info": "Information du client",
          "order-items": "Articles de la commande",
          "stock-management": "Gestion des stocks",
          "stock-total": "Total du stock",
          "rating": "Évaluation",
          "price": "Prix",

          "edit-stock-success": "Stock modifié avec succès !",
          "edit-stock-error": "Erreur lors de la modification du stock.",
          "delete-stock-success": "Stock vidé avec succès!",
          "delete-stock-error": "Erreur lors du vidage du stock.",
          "stock-msg": "Le stock ajouté sera appliqué à toutes les tailles du produit.",
          "back-to-products": "Retour aux produits",
          "insufficient-stock": "Stock insuffisant",

          // Coupon :
          "all-coupons": "Tous les coupons",
          "add-coupon": "Ajouter un coupon",
          "search-coupons": "Rechercher des coupons...",
          "add-coupon-success": "Coupon ajouté avec succès!",
          "add-coupon-error": "Erreur lors de l'ajout du coupon.",
          "edit-coupon-success": "Coupon modifié avec succès!",
          "edit-coupon-error": "Erreur lors de la modification du coupon.",
          "coupon-warning": "Vous devez saisir le code du coupon!",
          "delete-coupon-success": "Coupon supprimé avec succès!",
          "delete-coupon-error": "Erreur lors de la suppression du coupon.",
          "coupon-id": "Coupon ID",
          "coupons": "Coupons",
          "coupon": "Coupon",
          "cpn-code": "Code coupon",

          "promotions": "Offres",
          "add-promotion": "Ajouter une offre",
          "edit-promotion": "Modifier l'offre",
          "promo-name": "Nom de l'offre",
          "promo-rule": "Règle",
          "promo-buy": "Achetez",
          "promo-free": "offert(s)",
          "promo-buy-qty": "Quantité achetée",
          "promo-free-qty": "Quantité offerte",
          "promo-starts-at": "Début",
          "promo-ends-at": "Fin",
          "promo-dates-hint": "Laissez une date vide pour ne pas limiter de ce côté.",
          "promo-popup": "Popup",
          "promo-popup-enabled": "Afficher la popup d'annonce sur le site",
          "promo-popup-title": "Titre de la popup",
          "promo-popup-subtitle": "Sous-titre de la popup",
          "promo-popup-cta": "Texte du bouton",
          "promo-page-hint": "Achetez X, obtenez Y offert. Les articles les moins chers du panier sont offerts.",
          "promo-empty": "Aucune offre pour le moment.",
          "promo-live": "En cours",
          "promo-scheduled": "Programmée",
          "promo-expired": "Expirée",
          "promo-running-note": "est en cours — les codes promo sont désactivés pendant sa durée.",
          "promo-name-required": "Donnez un nom à l'offre.",
          "promo-qty-invalid": "Les quantités achetée et offerte doivent être au moins 1.",
          "promo-dates-invalid": "La date de fin doit être postérieure à la date de début.",
          "promo-created": "Offre créée.",
          "promo-updated": "Offre mise à jour.",
          "promo-save-error": "Impossible d'enregistrer l'offre.",
          "delete-promotion-success": "Offre supprimée avec succès !",
          "delete-promotion-error": "Erreur lors de la suppression de l'offre.",
          "promo-one-item-free": "Votre article le moins cher est offert.",
          "promo-n-items-free": "Vos {{num}} articles les moins chers sont offerts.",
          "promo-no-coupon-note": "Les codes promo ne sont pas cumulables avec cette offre.",
          "promo-nudge-one": "Ajoutez 1 article de plus et le moins cher est offert !",
          "promo-nudge-many": "Ajoutez {{num}} articles de plus et le moins cher est offert !",
          "promo-applied-at-checkout": "Votre remise est appliquée au paiement.",
          "active": "Active",
          "on": "Activée",
          "off": "Désactivée",
          "cpn-discount-type": "Type de remise",
          "cpn-value": "Valeur",
          "cpn-min-order": "Commande minimum",
          "cpn-expiry-date": "Date d'expiration",
          "cpn-usage-limit": "Limite d'utilisation",
          "fixed": "Montant fixe",
          "percentage": "Pourcentage",
          "generate": "Générer",
          "expired": "Expiré",

          "enter-coupon": "Entrez un code promo.",
          "coupon-invalid": "Coupon invalide.",
          "coupon-applied": "Coupon appliqué avec succès !",
          "coupon-error": "Coupon invalide.",
          "coupon-code-placeholder": "Code promo",
          "checking": "Vérification...",
          "apply": "Appliquer",
          "discount": "Remise",
          "discount-amount": "Discount amount",
          "times-used": "Nombre d'utilisations",

          "inactive": "Inactif",
          "id": "ID",
          "city-name": "Nom de la ville",
          "delivery-price": "Frais de livraison",
          "estimated-days": "Jours estimés",
          "delivery-cities": "Villes de livraison",
          "search-cities": "Rechercher des villes...",
          "add-city": "Ajouter une ville",
          "city-name-required": "Le nom de la ville est requis.",
          "delivery-price-invalid": "Le prix de livraison est invalide.",
          "add-city-success": "Ville ajoutée avec succès !",
          "add-city-error": "Erreur lors de l'ajout de la ville.",
          "edit-city-error": "Erreur lors de la récupération de la ville.",
          "edit-city-success": "Ville mise à jour avec succès !",
          "city-name-placeholder": "ex. Casablanca",
          "delete-delivery-error": "Erreur lors de la suppression de la ville de livraison.",
          "delete-delivery-success": "Ville de livraison supprimée avec succès !",

          "select": "Sélectionner",
          "select-all": "Tout sélectionner",
          "unselect-all": "Tout désélectionner",
          "edit-selected": "Modifier la sélection",
          "delete-selected": "Supprimer la sélection",
          "confirm-delete-selected": "Êtes-vous sûr de vouloir supprimer les villes sélectionnées ?",
          "bulk-update-success": "Les villes de livraison sélectionnées ont été mises à jour avec succès !",
          "bulk-update-error": "Erreur lors de la mise à jour des villes de livraison sélectionnées.",

          "loading": "Chargement",
          "delivery_with_price": "La livraison vous coûtera {{price}} MAD",
          "delivery": "Livraison",
          "free-delivery-label": "Livraison gratuite",
          "free-delivery-note": "Félicitations ! Les commandes de plus de {{threshold}} MAD bénéficient de la livraison gratuite.",
          "free-delivery-from": "Livraison gratuite à partir de",
          "minimum-amount": "Montant minimum (MAD)",
          "minimum-amount-invalid": "Le montant minimum est invalide",
          "threshold-saved": "Seuil enregistré avec succès",
          "activate-free-delivery": "Activer le seuil de livraison gratuite",
          "disabled": "Désactivé",

          "newsletter": {
            "title": "Newsletter",
            "text": "Restez informé de nos nouveautés, offres exclusives et tendances.",
            "fullname": "Nom complet",
            "email": "Adresse e-mail",
            "phone": "Numéro de téléphone",
            "subscribe": "S'abonner",
            "success": "Vous vous êtes abonné(e) avec succès à notre newsletter !",
            "error": "Une erreur s'est produite lors de l'inscription. Veuillez réessayer.",
            "warning": "Veuillez remplir au moins un champ avant d'envoyer !",
            "confirm-export": "Voulez-vous vraiment exporter tous les abonnés ?",
            "export-error": "Échec de l'export des abonnés.",
            "confirm-export-title": "Exporter les abonnés",
            "confirm-export-text": "Voulez-vous vraiment exporter tous les abonnés ?",
            "export-csv": "Exporter CSV",
            "export-success": "Export terminé avec succès !",
            "compose": "Composer une newsletter",
            "subject": "Objet",
            "message": "Message",
            "to-subscribers": "Abonnés à la newsletter",
            "to-customers": "Clients inscrits",
            "manual": "Ajouter des emails manuellement (séparés par des virgules)",
            "send": "Envoyer la newsletter",
            "sending": "Envoi...",
            "sent": "Newsletter envoyée à",
            "send-missing": "Veuillez saisir un objet et un message.",
            "send-no-recipients": "Veuillez choisir au moins un groupe de destinataires ou ajouter des emails.",
            "limit-note": "Note : l'hébergement mutualisé limite l'envoi en masse (~quelques centaines/heure). Pour de grandes listes, utilisez un service d'emailing dédié.",
          },
          "copyright": "© 2025 Thunder Maroc. Tous droits réservés.",
          "contact-info": "Informations de contact",
          "visit-us": "Nous rendre visite",
          "open-in-maps": "Ouvrir notre adresse dans Google Maps",
          "delete-newsletter-success": "Abonné supprimé avec succès !",
          "delete-newsletter-error": "Échec de la suppression de l'abonné.",

          "newsletter-list": "Abonnés à la newsletter",
          "export-csv": "Exporter en CSV",
          "search-client": "Rechercher un abonné...",
          "client-id": "ID Client",
          "full-name": "Nom complet",
          "date": "Date d'abonnement",
          "sort-newest": "Trier par plus ancien",
          "sort-oldest": "Trier par plus récent",
          "shipping-address": "Adresse de Livraison",
          "thank_you_purchase": "Merci pour votre achat",
          "cpn-usage-limit-per-user": "Limite d'utilisation par utilisateur",

          "messages": {
            "error_try_again": "Une erreur s'est produite, veuillez réessayer.",
            "coupon_not_found": "Aucun coupon trouvé avec ce code.",
            "coupon_inactive": "Ce coupon n'est plus actif.",
            "coupon_expired": "Ce coupon est expiré.",
            "coupon_usage_limit_reached": "Ce coupon a atteint sa limite d'utilisation.",
            "minimum_order_not_reached": "Le montant minimum de la commande n'est pas atteint.",
            "usage_limit_per_user_reached": "Vous avez atteint la limite d'utilisation pour ce coupon.",
            "session_or_user_required": "Vous devez être connecté ou fournir un identifiant de session pour utiliser le coupon.",
          },
          "increase_quantity": "Augmenter la quantité",
          "decrease_quantity": "Réduire la quantité",
          "selected-from": "sélectionné parmi",
          "update-product": "Mettre à jour le produit",
          "modify-product-details": "Modifiez les détails du produit ci-dessous.",
          "create-new-product": "Créer un nouveau produit",
          "fill-details-to-create-product": "Remplissez les informations ci-dessous pour créer une nouvelle annonce produit.",
          "english-name": "Nom en anglais",
          "french-name": "Nom en français",
          "english-description": "Description en anglais",
          "french-description": "Description en français",
          "select-gender": "Sélectionnez le genre",
          "select-category": "Sélectionnez la catégorie",
          "create-product": "Créer le produit",
          "is_nouvel_arrivage_question": "Est-ce un nouvel arrivage ?",
          "is_nouvel_arrivage_available_question": "Est-ce un nouvel arrivage disponible dans le stock ?",
          "is_nouvel_arrivage_available_question_note": "(il sera affiché dans la boutique)",
          "oui": "Oui",
          "non": "Non",
          "all-new-arrivals": "Tous les nouveaux arrivages",
          "new-arrivals": "Nouveaux arrivages",
          "new-arrival": "Nouvel arrivage",
          "new-arrivals-subtitle": "Découvrez Nos Derniers Produits",
          "new-arrivals-description": "Explorez les nouvelles additions à notre collection, mettant en avant les dernières tendances et des articles exclusifs. Soyez les premiers à saisir ces arrivées fraîches avant qu'elles ne disparaissent !",
          "available": "Disponible",
          "unavailable": "Indisponible",

          "error-google-auth": "Échec de l'authentification avec Google",
          "processing-auth": "Authentification en cours...",
          "please-wait": "Veuillez patienter un instant",
          "pre-order": "Précommande",
          "pre-orders": "Précommandes",
          "pre-order-text-1": "Réservez vos articles avant qu'ils ne soient officiellement disponibles. Vous recevrez une notification par e-mail dès que votre commande sera en stock et prête à être expédiée.",
          "pre-order-text-2": "Vous réservez un nouveau produit qui sera disponible prochainement.",
          "pre-order-text-3": "Nous vous informerons par e-mail lorsque le produit sera en stock et prêt à être expédié.",
          "place-pre-order": "Précommander",

          "add-bag-error-nouvel-arrivage": "Vous ne pouvez pas ajouter un produit en précommande tant qu'un produit disponible est dans votre panier. Finalisez d'abord votre commande en cours.",
          "add-bag-error-available-product": "Vous ne pouvez pas ajouter un produit disponible tant qu'un produit en précommande est dans votre panier. Finalisez d'abord votre précommande.",

          "all-pre-orders": "Toutes les précommandes",
          "all-pre-orders-1": "Aucune précommande n'a été passée pour le moment.",
          "search-pre-orders": "Rechercher des précommandes...",

          "preorder-availability-alert": "Nous vous informerons par email dès que vos produits seront disponibles.",
          "preorder-confirm-header": "Confirmer les modifications",
          "preorder-confirm-text": "Cette précommande sera déplacée vers les commandes. \n Et un email de confirmation sera envoyé au client.",
          "preorder-cancel-header": "Annuler la précommande",
          "preorder-cancel-text": "Cette précommande sera annulée.",

          "order-confirm-text": "Cette commande sera traitée. \n Et un email de confirmation sera envoyé au client.",
          "order-cancel-header": "Annuler la commande",
          "order-cancel-text": "Cette commande sera annulée.",
          "email-doesnt-exist-err": "L'adresse e-mail fournie n'existe pas.",
          "2pic-uploaded": "2 photos doivent être téléchargées.",
          "replace-imgs": "Remplacer les images (exactement 2 fichiers)",
          "2pic-existing-files": "Si vous téléchargez des images, elles doivent être exactement au nombre de 2 et remplaceront les images existantes.",

          "forgot-password-title": "Mot de passe oublié ?",
          "forgot-password-text": "Entrez simplement votre adresse e-mail ci-dessous et nous vous enverrons les instructions pour réinitialiser votre mot de passe.",
          "reset-password": "Réinitialiser le mot de passe",
          "reset-password-title": "Réinitialiser votre mot de passe",
          "reset-password-text": "Veuillez entrer un nouveau mot de passe ci-dessous pour réinitialiser votre compte. Assurez-vous qu'il soit sécurisé et facile à retenir.",
          "notif-reset-link-title": "Notification de Réinitialisation de Mot de Passe",
          "notif-reset-link-text": "Le lien de réinitialisation de mot de passe a été envoyé à votre adresse e-mail. Veuillez vérifier votre boîte de réception et noter qu'il peut avoir été reçu dans votre dossier spam.",
          "iunderstand": "Je comprends",
          "er-forgotpsw": "Aucun compte n'a été trouvé pour cette adresse électronique",

          "promo-newPrice": "Nouveau prix",
          "promo-oldPrice": "Prix Original",
          "promo-promotionLabel": "Promotion",
          "promo-addSuccess": "Promotion ajoutée avec succès !",
          "promo-addError": "Impossible d'ajouter la promotion. Veuillez vérifier les informations et réessayer.",
          "activate-promotion": "Activer la promotion",

          "background-color": "Couleur d'arrière-plan",
          "text-color": "Couleur du texte",
          "show-button-on-slide": "Afficher le bouton sur cette diapositive",
          "note-empty-title-description-slides": "Vous pouvez laisser les champs « Titre » et « Description » vides ; seule l'image s'affichera dans la diapositive.",
          "info-alert": "Alerte info!",

        }
      }
    },
    lng: savedLanguage,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
